export default function SoftvisionAboutDialogTemplate(data) {
    //language=HTML
    return `
        <div id="aboutDialog">
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("appVersionNumber")}
            </span>
                <span class="col-md-9">
                ${data.applicationVersion}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("dbBuildDate")}
            </span>
                <span class="col-md-9">
                ${data.dbBuildDate}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("latestRelease")}
            </span>
                <span class="col-md-9">
                ${data.latestRelease}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("customerSupportEndDate")}
            </span>
                <span class="col-md-9">
                ${data.customerSupportEndDate}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("licenceDetails")}
            </span>
                <span class="col-md-9">
                ${data.licenceDetails}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("contactInfo")}
            </span>
                <span class="col-md-9">
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("egypt")}
            </span>
                <div class="col-md-9">
                    <address class="namaAddress">SoftVision Business Solutions –  LLC</address>
                    <address class="namaAddress">45 شارع قمبيز – نادي الصيد – الدقي – الجيزة – مصر.</address>
                    <address class="namaAddress">45 Kambez St., Nadi Al-Saeed, Dokki, Giza Governorate, Egypt.</a></address>
                    <address class="namaAddress"><a href="tel:00233365113">00233365113</a></address>
                    <address class="namaAddress"><a href="tel:00201000442100">00201000442100</a></address>
                    <address class="namaAddress">
                        <a href="emailto:info@softvisiongroup.com">info@softvisiongroup.com</a>
                    </address>
                    <address class="namaAddress">
                        <a href="https://www.linkedin.com/company/soft-vision/">www.softvisiongroup.com</a>
                    </address>
                </div>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("egypt")}
            </span>
                <div class="col-md-9">
                    <address class="namaAddress">37 شارع عمان - الدقي - الجيزة - مصر</address>
                    <address class="namaAddress">37 Amman Square , Dokki, Giza ,Egypt</address>
                    <address class="namaAddress"><a href="tel:00237615120">00237615120</a></address>
                    <address class="namaAddress">
                        <a href="emailto:info@namasoft.com">info@namasoft.com</a>
                    </address>
                    <address class="namaAddress">
                        <a href="https://www.facebook.com/namasoft" target="_blank">
                            <img src="images/fb.png" class="fb-logo" style="height: 32px;width: 32px"/>
                        </a>
                        <a href="https://www.twitter.com/namasoft" target="_blank">
                            <img src="images/tw.jpg" class="tw-logo" style="height: 32px;width: 32px"/>
                        </a>
                        <a href="https://www.youtube.com/c/namasoft" target="_blank">
                            <img src="images/yt.png" class="tw-logo" style="height: 32px;width: 32px"/>
                        </a>
                    </address>
                </div>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("saudiArabia")}
            </span>
                <div class="col-md-9">
                    <address class="namaAddress">الطريق الدائري الشرقي، بين مخرج 13 و مخرج 14، حى الربوة، الرياض، 11655، المملكة العربية السعودية
                    </address>
                    <address class="namaAddress">Eastern Ring Branch Road, Between Exit 13 and Exit 14, Ar Rabwah, Riyadh, 11655, Saudi Arabia
                    </address>
                    <address class="namaAddress"><a href="tel:00966114922213">00966114922213</a></address>
                    <address class="namaAddress"><a href="tel:00966539147179">00966539147179</a> - <a href="tel:00966583670970">00966583670970</a>
                    </address>
                    <address class="namaAddress">
                        <a href="emailto:info@namasoft.com">info@namasoft.com</a>&nbsp;
                    </address>
                    <address class="namaAddress">
                        <a href="https://www.facebook.com/namasoftksa" target="_blank">
                            <img src="images/fb.png" class="fb-logo" style="height: 32px;width: 32px"/>
                        </a>
                        <a href="https://www.twitter.com/namasoftksa" target="_blank">
                            <img src="images/tw.jpg" class="tw-logo" style="height: 32px;width: 32px"/>
                        </a>
                    </address>
                </div>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("kuwait")}
            </span>
                <div class="col-md-9">
                    <address class="namaAddress">شركة إكسيد لأنشطة البرمجة الحاسوبية - حولي ،شارع تونس ، برج كابيتال</address>
                    <address class="namaAddress">Exceed Computer Programming Co. - Hawalli - Tunis Street - Capital Tower</address>
                    <address class="namaAddress"><a href="tel:0096550634517">0096550634517</a></address>
                    <address class="namaAddress"><a href="tel:0096522070208">0096522070208</a></address>
                </div>
            </div>
            <div class="row topBordered w-100">
                <div class="col-md-12">
                    <div class="textAlignCenter">
                        <a href='${data.translateId("appUrl")}' target="_blank">${data.translateId("appUrl")}</a>
                    </div>
                </div>
            </div>
        </div>`;
}